/** @format */
import axios from "axios";
import { Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";

import Add from "./Add";
import Table4 from "./Table4";
import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";
import sxema from "../../../../icons/oqjar-qizilqishloq.png";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";
import {
  getDateColumnsInRange,
  getDefaultRange,
  getMonthRange,
  getMonthsInRange,
  isValidRange,
  normalizeRangeRows,
} from "../ravotxoji/rangeHelpers";

const createEmptyOqjarRow = (column) => ({
  sana: column.date,
});

const normalizeOqjarMonthRows = (month, rows) => {
  const monthRange = getMonthRange(month);

  if (!monthRange) {
    return rows || [];
  }

  const columns = getDateColumnsInRange(monthRange.from, monthRange.to);

  return normalizeRangeRows(
    { [month]: rows || [] },
    columns,
    createEmptyOqjarRow
  );
};

const Oqjar = () => {
  const defaultRange = getDefaultRange();
  const [data, setData] = useState([]);
  const [rangeData, setRangeData] = useState([]);
  const [date, setDate] = useState("");
  const [toggle, setToggle] = useState(1);
  const [range, setRange] = useState(defaultRange);
  const [localRange, setLocalRange] = useState(defaultRange);
  const [loading, setLoading] = useState(false);

  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);

  const tabs = [
    { title: "Oraliq", id: 1, type: "text" },
    { title: "Oylik", id: 2, type: "text" },
    { title: "Sxema", id: 3, type: "text" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/oqjar/index?month=" +
            month,
          header()
        );
        setData(normalizeOqjarMonthRows(month, res.data));
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [month]);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  useEffect(() => {
    if (toggle !== 1) {
      return;
    }

    if (!isValidRange(range)) {
      setRangeData([]);
      return;
    }

    const fetchRangeData = async () => {
      setLoading(true);
      const columns = getDateColumnsInRange(range.from, range.to);
      const months = getMonthsInRange(range.from, range.to);

      try {
        const responses = await Promise.all(
          months.map((rangeMonth) =>
            axios.get(
              getEnv('REACT_APP_BASE_URL') +
                "/v1/region/oqjar/index?month=" +
                rangeMonth,
              header()
            )
          )
        );
        const monthlyData = {};
        months.forEach((rangeMonth, index) => {
          monthlyData[rangeMonth] = responses[index]?.data || [];
        });
        setRangeData(
          normalizeRangeRows(monthlyData, columns, createEmptyOqjarRow)
        );
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
        setRangeData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRangeData();
  }, [range, toggle]);

  const applyRange = () => {
    if (!isValidRange(localRange)) {
      alert("Sana oralig'ini to'g'ri kiriting!");
      return;
    }

    setRange(localRange);
  };

  return (
    <div>
      <ContentTop>
        <ul
          className='content-top-left suv-omborlari'
          style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <li>Oqjar va Qizilqishloq</li>

          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          {toggle === 1 ? (
            <>
              <span className='text-muted small mr-2'>Dan</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.from}
                onChange={(e) =>
                  setLocalRange({ ...localRange, from: e.target.value })
                }
              />
              &nbsp;&nbsp;
              <span className='text-muted small mr-2'>Gacha</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.to}
                onChange={(e) =>
                  setLocalRange({ ...localRange, to: e.target.value })
                }
              />
              &nbsp;&nbsp;&nbsp;
              <button
                className='btn btn-outline-primary btn-sm'
                onClick={applyRange}>
                Ok
              </button>
            </>
          ) : toggle === 2 ? (
            <input
              type='month'
              className='form-control form-control-sm'
              value={lmonth}
              onChange={(e) => setLmonth(e.target.value)}
            />
          ) : null}
        </ul>
      </ContentTop>

      <div className='tabs-content table-box'>
        <div className='tabs-content-item active'>
          {toggle !== 3 ? (
            loading ? (
              <LoadingCard loading={loading} heightSize='80vh' />
            ) : (
            <Routes>
              <Route
                path='/'
                element={
                  <Table4
                    isRange={toggle === 1}
                    month={toggle === 2 ? month : range.from.slice(0, 7)}
                    data={toggle === 2 ? data : rangeData}
                    setDate={setDate}
                  />
                }
              />
              <Route
                path='/add'
                element={<Add date={date} setDate={setDate} />}
              />
            </Routes>
            )
          ) : (
            <div className='card statistic-card w-100'>
              <div className='container-fluid oqjar-sxema'>
                <span className='span1'>O'zbekiston - 3.5 m3/s</span>
                <span className='span2'>Qozog'iston - 6.1 m3/s</span>
                <span className='span3'>240 m3/s</span>
                <span className='span4'>23 m3/s</span>
                <span className='span5'>80 m3/s</span>
                <span className='span6'>50 m3/s</span>
                <span className='span7'>35 m3/s</span>
                <span className='span8'>92 m3/s</span>
                <span className='span9'>158 sm</span>
                <span className='span10'>29 sm</span>
                <span className='span11'>29 m3/s</span>
                <span className='span12'>29 m3/s</span>
                <span className='span13'>3006 mln.m3</span>
                <span className='span14'>29 m3/s</span>
                <span className='span15'>29 m3/s</span>
                <img src={sxema} alt='404' className='suv-omborlari-img' />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Oqjar;
